import round from 'lodash/round';

import { TFunction } from '@lyearn/i18n';
import {
  CheckMarkCircle2,
  Mastery1Outline,
  Mastery2Outline,
  Mastery3Outline,
  Mastery4Outline,
} from '@lyearn/icons';
import { Box, Stack, StatusPill, Typography } from '@lyearn/ui';

const getProgressPillIcon = (progress: number) => {
  if (progress === 100) {
    return CheckMarkCircle2;
  } else if (progress >= 40 && progress < 60) {
    return Mastery2Outline;
  } else if (progress >= 60 && progress < 80) {
    return Mastery3Outline;
  } else if (progress >= 80 && progress < 100) {
    return Mastery4Outline;
  }
  return Mastery1Outline;
};

export const renderProgressStatus = (t: TFunction, progress = 0) => {
  const isCompleted = progress === 100;
  const appearance = isCompleted ? 'success' : 'warning';
  const textColor = isCompleted ? 'text-text-success' : 'text-text-warning';
  const iconColor = isCompleted ? 'icon-success' : 'icon-warning';
  const Icon = getProgressPillIcon(progress);

  return (
    <Box className="mt-auto">
      <StatusPill
        appearance={appearance}
        label={
          <Stack alignItems="center" gapX={6}>
            {Icon && <Icon className="h-16 w-16 self-center" fillColorToken={iconColor} />}
            <Typography color={textColor} variant="body-short-03">
              {`${round(progress, 0)}%`}
            </Typography>
          </Stack>
        }
        size="medium"
        variant="light"
      />
    </Box>
  );
};
